import api from '@/utils/api';

export default {

     async getCompany( accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get('/company', {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da empresa:', error);
            throw error;
        }
    },
    async editCompany( accessToken ,payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.put(`/company`, payload, {
                method: 'PUT',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ataulizar dados da empresa:', error);
            throw error;
        }
    },

    async changeCompany( accessToken, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/auth/redirect', payload, {
                method: 'POST',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao redirecionar para a empresa:', error);
            throw error;
        }
    },
    async getVideoteca(accessToken) {
        const response = await api.get('/company/videoteca', {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return response.data;
    },
    async linkVideotecaAccount(accessToken, payload) {
        const response = await api.put('/company/videoteca/account', payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    async createVideotecaFolder(accessToken) {
        const response = await api.post('/company/videoteca/folder', {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
}